export default __webpack_public_path__ + "static/black_7th_Background_wh-31802ea45ce4cca1edfb218bb957688d.webp";